// extracted by mini-css-extract-plugin
export var cardBody = "bT_f7";
export var cardContent = "bT_f5";
export var cardFooter = "bT_f6";
export var container = "bT_cq";
export var gridCardAParent = "bT_f8";
export var imageContainer = "bT_bX";